<div class="form-container">
  
  <div class="subform-container">
    <div class="title-text">{{getString('changeEmailText')}}</div>
    <div class="form-field">
      <app-input-field [type]="'email'" [placeholder]="getString('newEmailAddress')" (valueChanged)="onEmailChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [type]="'email'" [placeholder]="getString('confirmNewEmailAddress')" (valueChanged)="onConfirmEmailChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <button type="button" class="blue-button" (click)="changeEmail()">{{getString('change')}}</button>
      <button type="button" (click)="close.emit()">{{getString('cancel')}}</button>
    </div>

    <div class="message-container">
        <div class="red-text" *ngIf="invalidEmail">{{getString('invalidEmail')}}</div>
        <div class="green-text" *ngIf="emailChangeSuccess">
          {{getString('success')}}!
          <div><button (click)="close.emit()">{{getString('ok')}}</button></div>
        </div>
        <div class="red-text" *ngIf="serverError">{{serverMessage}}</div>
    </div>

  </div>

</div>